import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    dashboardCardTitleContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    modalOverlay: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    photoLoadingOverlay: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    photoDeleteButton: {
        justifyContent: "center",
        position: "absolute",
        alignItems: "center",
        height: 28,
        width: 28,
        right: 4,
        top: 4
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        flex: 1
    },
    contentContainer: {
        flexDirection: "column"
    },
    photoDeleteButtonInner: {
        height: 32,
        width: 32
    },
    actionsContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    photoGrid: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    photoContainer: {
        position: "relative",
        overflow: "hidden"
    },
    coverAndLogoContainer: {
        position: "relative",
        overflow: "hidden"
    },
    logoImage: {
        position: "absolute",
        resizeMode: "cover",
        height: 64,
        width: 64
    },
    modalCloseButton: {
        position: "absolute",
        zIndex: 1,
        right: 20,
        top: 40
    },
    coverImage: {
        alignSelf: "center",
        resizeMode: "cover",
        aspectRatio: 4 / 5,
        maxHeight: 480,
        width: "100%"
    },
    photoContainerInner: {
        height: 150,
        width: 150
    },
    photoImage: {
        height: "100%",
        width: "100%"
    },
    coverPlaceholder: {
        width: "100%",
        height: 300
    },
    lightboxImage: {
        height: "80%",
        width: "90%"
    },
    dashboardCard: {
        width: "100%"
    },
    dummyInfoBadge: {
    },
    previewImage: {
        width: 120,
        height: 120
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
